import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { exportProjectFiles } from './export.thunks';

type ExportsSliceState = {
  exporting: { [baseName: string]: true };
};

const initialState: ExportsSliceState = {
  exporting: {},
};

export const exportsSlice = createSlice({
  name: 'exports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(exportProjectFiles.pending, (state, action) => {
      state.exporting[action.meta.arg.file.json.baseName] = true;
    });
    builder.addMatcher(
      isAnyOf(exportProjectFiles.fulfilled, exportProjectFiles.rejected),
      (state, action) => {
        delete state.exporting[action.meta.arg.file.json.baseName];
      },
    );
  },
});

export const exportsReducer = exportsSlice.reducer;
